import Icon from '../components/Icon.vue'

Icon.register({"square-full":{"width":512,"height":512,"paths":[{"d":"M512 512H0V0H512V512z"}]}})
